import React, { useEffect } from "react";
import education from "../assets/images/education.png";
import EducationList from "./EducationList";
import AOS from "aos";
import "aos/dist/aos.css";

const Education = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <div
      className="flex flex-col md:px-8 md:flex-row lg:mt-5 lg:px-8 lg:flex-row items-center font-montserrat pb-3 xl:justify-center xl:mt-8"
      data-aos="fade-right"
    >
      <img
        src={education}
        alt="Education"
        className="w-5/6 lg:w-1/2 md:w-1/2 xl:w-1/3 mb-5"
      />
      <div className="lg:w-1/2 md:w-1/2 xl:w-1/3 flex flex-col items-center">
        <h3 className="font-semibold text-2xl">Education</h3>
        <EducationList
          year="2006 - 2012"
          name="Sudimara 6 Public Elementary School"
        />
        <EducationList
          year="2012 - 2014"
          name="Budi Mulia Junior High School"
        />
        <EducationList year="2014 - 2017" name="Budi Mulia Senior High School">
          <div className="text-xs font-thin">
            Natural Science Specialization
          </div>
        </EducationList>
        <EducationList year="2017 - Now" name="Budi Luhur University">
          <div className="text-xs font-thin">
            Faculty of Information Technology
          </div>
          <div className="text-xs font-thin">Majors Information System</div>
        </EducationList>
      </div>
    </div>
  );
};

export default Education;
